import {getBackend} from '../utils/backend';
import useSWR from 'swr';
import {useAuth} from '../providers/auth';
import {GET_TALKING_POINTS_QUERY_KEY} from '../config/misc';

const useGetTalkingPoints = () => {
  const {identity} = useAuth();

  const response = useSWR(identity ? GET_TALKING_POINTS_QUERY_KEY : null, async () => {
    if (!identity) {
      throw new Error('identity is not defined');
    }
    const backend = await getBackend(identity);
    const talkingPoints = await backend.getTalkingPoints();
    return talkingPoints;
  });

  return response;
};

export default useGetTalkingPoints;
